<template>
    <div>

        <TextBanner>
            Über den Mond bis zum Mars: Die Nasa startet in eine neue Ära. In Zukunft sollen sogar Menschen zum Mars reisen können.<br><p></p>
            <p>Drehen Sie die Objekte und entdecken Sie u.a. die Seite des Mondes, die wir von der Erde aus nie sehen.</p>
        </TextBanner>

        <InfoBox modalName="IB_Mond">
            <template #title>Unser Trabant</template>
            <template #subline></template>
            <template>
                <p>Der Mond umläuft die Erde in einer elliptischen Bahn. Dadurch schwankt sein Abstand zur Erde zwischen 362.102 und 404.694 Kilometern. Da der Mond keine Atmosphäre hat, wechseln die Temperaturen bei Licht und Schatten extrem: 
                    Bei Sonne kann es auf der Oberfläche bis zu +130 °C heiß werden. Im Schatten sind –162 °C möglich.</p>


                <!-- Bild, lazyload -->
                <figure>
                    <div class="lazy-container bg-dark">
                        <span class="zdf-load-icon"></span>
                        <!-- required (ratio): data-width, data-height -->
                        <img class="img-fluid" data-width="600" data-height="375" v-lazy="require('../assets/img/010_mondlandung_thb.jpg')" alt="">
                    </div>
                    <figcaption>
                        <div class="legal">&copy; Nasa</div>
                        Die erste Mondlandung 1969
                    </figcaption>
                </figure>

                <p>Bisher gab es sechs erfolgreiche bemannte Mond-Missionen. Am 20. Juli 1969 landete Apollo 11 auf dem Mond. Neil Armstrong und Buzz Aldrin waren am 21. Juli die ersten Besucher des Erdtrabanten. 
                    Fünf weitere Apollo-Mondmissionen brachten Menschen dorthin. 1972 zum letzten Mal. </p>


            </template>
        </InfoBox>


        <InfoBox modalName="IB_Rueckseite">
            <template #title>Die Rückseite des Mondes</template>
            <template #subline></template>
            <template>

                <p>Die Animation erklärt, warum wir immer nur eine Seite des Mondes von der Erde aus sehen.</p>
                <!--<p>Die Rückseite des Mondes ist von der Erde aus nie zu sehen. In den 27,3 Tagen, die der Mond für die Umrundung der Erde braucht, dreht er sich genau einmal um die eigene Achse. 
                    Das hängt mit der starken Gravitationskraft der Erde zusammen. Sie bremst den viel kleineren Mond in seiner Eigenrotation so ab, dass sich die Rotation an die Umlaufzeit angepasst hat. 
                    Stets ist also die gleiche Seite des Mondes der Erde zugewandt.</p>
                -->
                <!-- ZDFPlayer -->
                <figure>
                    <ZDFPlayer
                        data-jsb='{"config":"https://3d.zdf.de/mission-artemis/video/3Dconfiguration.json", "content":"https://3d.zdf.de/mission-artemis/video/010_maz_rueckseite.json"}'></ZDFPlayer>
                    <figcaption>
                        <div class="legal"></div>
                    </figcaption>
                </figure>

                <p>Am 3. Januar 2019 ist die chinesische Raumsonde Chang‘e 4 auf der Rückseite des Mondes gelandet. 
                    Mit dem Mondfahrzeug Yutu-2 erforschen die Chinesen den südpolaren Mondbereich um den Aitken-Krater. </p>

                <!-- FullscreenImage, lazyload -->
                <FullscreenImage :src="require('../assets/img/010_jadehase.jpg')">
                    <figure>
                        <div class="lazy-container bg-dark">
                            <span class="zdf-load-icon"></span>
                            <!-- required (ratio): data-width, data-height -->
                            <img class="img-fluid" data-width="1024" data-height="1024" v-lazy="require('../assets/img/010_jadehase.jpg')" alt="">
                        </div>
                        <figcaption>
                            <div class="legal">&copy; dpa</div>
                            Foto des chinesischen Mondfahrzeugs Jadehase, das auf der Rückseite des Mondes unterwegs ist.
                        </figcaption>
                    </figure>
                </FullscreenImage>

            </template>
        </InfoBox>

        <InfoBox modalName="IB_Mars">
            <template #title>Der rote Planet</template>
            <template #subline></template>
            <template>
                <p>Der durch das eisenhaltige Gestein rötlich schimmernde Mars ist im Durchschnitt 70 Millionen Kilometer weiter von der Sonne entfernt als die Erde. 
                    Da beide Planeten immer in Bewegung sind, variiert die Entfernung. Alle 16 Jahre kommen sich Mars und Erde besonders nah, dann sind sie „nur“ 56 Millionen Kilometer 
                    voneinander entfernt. Der Mars hat eine sehr dünne Atmosphäre, und die Temperaturen schwanken dort stark. Am Mars-Äquator liegen sie zwischen −80 °C und +20 °C.</p>

                <!-- FullscreenImage, lazyload -->
                <FullscreenImage :src="require('../assets/img/010_mars.jpg')">
                    <figure>
                        <div class="lazy-container bg-dark">
                            <span class="zdf-load-icon"></span>
                            <!-- required (ratio): data-width, data-height -->
                            <img class="img-fluid" data-width="700" data-height="467" v-lazy="require('../assets/img/010_mars_thb.jpg')" alt="">
                        </div>
                        <figcaption>
                            <div class="legal">&copy; Nasa</div>
                        Foto vom Mars-Rover Perseverance.
                        </figcaption>
                    </figure>
                </FullscreenImage>

                <p>Derzeit laufen unterschiedliche Mars-Missionen. 2021 landete die chinesische Raumsonde Tianwen-1 mit dem Rover Zhurong auf dem roten Planeten.</p>


                <p>Ebenfalls 2021 landete der Nasa-Rover Perseverance. Neben dem Rover nimmt auch ein Hubschrauber namens Ingenuity an der Mission teil. 
                    Am 19. April 2021 führte Ingenuity den allerersten motorisierten Flug auf einem anderen Planeten durch.</p>

                <!-- FullscreenImage, lazyload -->
                <FullscreenImage :src="require('../assets/img/010_ingenuity.jpg')">
                    <figure>
                        <div class="lazy-container bg-dark">
                            <span class="zdf-load-icon"></span>
                            <!-- required (ratio): data-width, data-height -->
                            <img class="img-fluid" data-width="512" data-height="512" v-lazy="require('../assets/img/010_ingenuity_thb.jpg')" alt="">
                        </div>
                        <figcaption>
                            <div class="legal">&copy; Nasa</div>
                        Foto des Mars-Helikopters Ingenuity.                        
                        </figcaption>
                    </figure>
                </FullscreenImage>

            </template>
        </InfoBox>

        <!-- Fallback -->
        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/fallback_P.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/fallback_L.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <img src="../assets/img/fallback/fallback.jpg" alt="">
            </picture>
            <div class="hotspot" v-on:click="infobox('IB_Mond')"></div>
            <div class="hotspot" v-on:click="infobox('IB_Rueckseite')"></div>
            <div class="hotspot" v-on:click="infobox('IB_Mars')"></div>
        </Fallback>


    </div>
</template>

<script>
    export default {
        name: 'infobox',
        babylonState: {
            camera: {
                position: [-1.55,1.61,47],  //0,1.5,50       003: -2.2,1.5,40  -.8,1.2,80
                target: [-5,0,0],    //Mondfocus -5,0,0  MitteMarsMond -5,0,5]  003:-5,0,0
                betaLimits: [0.1, 3.1],   //[0.1, Math.PI / 2]
                clipping: [4, 10000.0],   //[6, 10000.0]
            },


            //gestaffelte Einstellung Planeten: [-14.13,1.61,47]
            
            artemis_geo: {


                Station_All:{
                    visible: false,
                },

                //  Label_Pixel:{
                //     billboardMode:7
                // },

                // // Label_3474km:{
                // //     //position: [5,5,5],
                // //     visible: true,
                // //     billboardMode: 7, 
                // //     //renderingGroupId:1,
                // // },
                // // Label_6779km:{
                // //     visible: true,
                // //     //billboardMode: 7,
                // //     //renderingGroupId:1,
                // // },

                    Erde:{
                        //position:[-600,0,-500],
                        fade:true,
                        visible: true
                    },

                Sonne: {
                    fade: true,
                    visible: true
                    },
                Weltall:{
                    fade: false,
                    visible: false,
                    },
                Mond:{
                    pickable: true,
                },
                Mars:{
                    //position: [100,100,-700],
                    fade: true,
                    visible: true,
                    pickable: false,
                    },
                Schatten_Mars: {
                    fade: true,
                    visible: true,
                    pickable:false,
                    },
                Schatten_Mond: {
                    fade: true,
                    visible: true,
                    pickable:false,
                    },
                Schatten_Erde: {
                    fade: true,
                    visible: true,
                    pickable:false,
                    },

                Label_Durchmesser_Mond:{
                    //billboardMode:2,
                    visible: true,
                    pickable: false,
                    },
                Label_Durchmesser_Mars:{
                    visible: true,
                    pickable: false,
                    },
                Label_Durchmesser_Erde:{
                    billboardMode: 0,
                    visible: true,
                    pickable: false,
                    },

                Label_Gateway: {
                    Text_Gateway:{
                        renderingGroupId:0
                    },
                    fade: false,
                    visible: false,
                    renderingGroupId: 0,
                    billboardMode: 7,
                },
            },

            // planeten:{
            //         Cube_Weltall: {
            //             visible: false
            //         }
            // },

            hotspots: {
                info_1: {
                    visible: true,
                    infoBox: 'IB_Mond',
                    position: [-5, 5, 0],
                    scale: 6,
                },

                info_2: {
                    visible: true,
                    infoBox: 'IB_Rueckseite',
                    position: [-4, 0, 2.8],  //-6, 0, 2.8],
                    scale: 4,
                },

                info_3: {
                    visible: true,
                    infoBox: 'IB_Mars',
                    position: [0, 9.5, 11.2],
                    scale: 6,
                }
            },
           
        },
        babylonReady: function () {

        this.$babylonController.timer.add(2400, () => {
            this.$babylonController.setCameraRadiusLimit(12,150);
        });

        this.$babylonController.timer.add(2400, () => {
            this.$babylonController.setClipping(8,100000);
        });

        //this.$audioController.initTrack('loop', require('./../assets/audio/2496003_Starhorizon_192.mp3'), true, false);   //'speaker

        },
    }
</script>

<style scoped lang="scss">

    .fallback-container .hotspot {

        left: 65vw;
        top: 40vh;

        @media (orientation: landscape) {
            left: 60vw;
            top: 35vh;
            transform: scale(0.75);
        }
    }


</style>
